/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 09:53:13
 * @lastTime: 2023-11-10 16:48:27
 * @LastEditors: caiqin.xie
 * @message: 新闻-热门话题
 */
import React, { useState } from "react";
import { Affix } from '@arco-design/web-react';
import styles from "./index.module.scss";
import { Link } from "react-router-dom";

interface IProps {
  ctry: string;
  words: Record<string, string>;
}

const HotTopic = (props: IProps) => {
  const {ctry, words} = props
  return (
    <Affix className={styles['fixed-top']} affixClassName={styles['news-top']}>
      <div className={styles['top-content']}>
        <div className={styles['top-header']}>
          <Link to={`/${ctry}/newsroom`}>
            <h2 className={styles['title']}>
              {words?.newsroom_hot_topic_title}
              {/* Newsroom */}
            </h2>
          </Link>
        </div>
      </div>
    </Affix>
  )
}
export default HotTopic 